import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import constants from "../Constants/constants";
import { getSetPurchaseUrl, isUnlimitedCard, getDualSideName } from "./deckUtils";

export default class CardDetailModal extends Component {
  render() {
    const {
      card, darkMode, results, modalFromPreview,
      onClose, onPrev, onNext,
      onAdd, onRemove, onRemoveAll,
      getCardCount, getRarityClass,
      onTouchStart, onTouchEnd,
      cardUsageStats,
      deckImage, onSetCover,
      onFlipCard,
    } = this.props;

    if (!card) return null;

    const isCover = deckImage === card.image;

    const themeClass = darkMode ? "modal-dark" : "modal-light";

    const modalStyle = { backgroundColor: darkMode ? "#2a2a3a" : "#ffffff" };
    const currentIndex = results.length > 0 ? results.findIndex(c => c._id === card._id) : -1;
    const canGoPrev = currentIndex > 0;
    const canGoNext = currentIndex < results.length - 1;
    const showNavigation = results.length > 1 && !modalFromPreview;

    const copyCount = getCardCount(card._id);
    const unlimited = isUnlimitedCard(card);
    const maxCopies = card.cardType === "Field" ? 1 : unlimited ? Infinity : 3;
    const canAdd = copyCount < maxCopies;
    const dualSideName = getDualSideName(card);

    return (
      <div
        className={`db-card-modal-overlay ${themeClass}`}
        onClick={onClose}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        role="dialog"
        aria-modal="true"
        aria-labelledby="card-modal-name"
      >
        {showNavigation && (
          <>
            <button
              className={`db-modal-nav-btn db-modal-nav-prev ${!canGoPrev ? "disabled" : ""}`}
              onClick={(e) => { e.stopPropagation(); onPrev(); }}
              disabled={!canGoPrev}
              aria-label="Previous card"
            >
              <ChevronLeftIcon />
            </button>
            <button
              className={`db-modal-nav-btn db-modal-nav-next ${!canGoNext ? "disabled" : ""}`}
              onClick={(e) => { e.stopPropagation(); onNext(); }}
              disabled={!canGoNext}
              aria-label="Next card"
            >
              <ChevronRightIcon />
            </button>
          </>
        )}

        <div className={`db-card-modal ${themeClass}`} style={modalStyle} onClick={(e) => e.stopPropagation()}>
          <button className="db-modal-close-btn" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </button>

          <div className="db-modal-content" style={modalStyle}>
            <figure className="db-modal-image">
              <img src={`${constants.DOMAIN}${card.image}`} alt={`${card.name} - ${card.cardType}`} />
              {dualSideName && onFlipCard && (
                <button
                  className="flip-card-btn"
                  onClick={() => onFlipCard(dualSideName)}
                  aria-label={`Flip to ${dualSideName}`}
                  title={`Flip to ${dualSideName}`}
                >
                  ↻ Flip
                </button>
              )}
            </figure>

            <div className="db-modal-footer">
              {getSetPurchaseUrl(card.cardSet) ? (
                <a
                  className="db-modal-set db-modal-set-link"
                  href={getSetPurchaseUrl(card.cardSet)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {card.cardSet} 🛒
                </a>
              ) : (
                <span className="db-modal-set">{card.cardSet}</span>
              )}
            </div>

            <div className="db-modal-actions">
              {!modalFromPreview && onSetCover && (
                <button
                  className={`db-modal-cover-btn ${isCover ? "active" : ""}`}
                  onClick={() => { onSetCover(card.image); }}
                  aria-label={isCover ? "Current cover image" : `Set ${card.name} as cover image`}
                  title={isCover ? "Cover image" : "Set as cover"}
                >
                  {isCover ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                  {isCover ? " Cover Image" : " Set as Cover"}
                </button>
              )}
              {!modalFromPreview && (
                <div className="db-modal-btn-row">
                  <button
                    className={`db-modal-add-btn ${!canAdd ? "disabled" : ""}`}
                    onClick={() => { onAdd(card); }}
                    disabled={!canAdd}
                  >
                    {unlimited ? `Add (${copyCount})` : canAdd ? `Add (${copyCount}/${maxCopies})` : `Max (${copyCount}/${maxCopies})`}
                  </button>
                  <button
                    className={`db-modal-remove-btn ${copyCount === 0 ? "disabled" : ""}`}
                    onClick={() => { onRemove(card._id); }}
                    disabled={copyCount === 0}
                  >
                    -1
                  </button>
                  <button
                    className={`db-modal-remove-all-btn ${copyCount <= 1 ? "disabled" : ""}`}
                    onClick={() => { onRemoveAll(card._id); }}
                    disabled={copyCount <= 1}
                  >
                    Remove All
                  </button>
                </div>
              )}
            </div>

            {(() => {
              const deckCount = cardUsageStats && cardUsageStats.totalDecks > 0
                ? cardUsageStats.cardUsage[card._id] || 0 : 0;
              const hasStats = cardUsageStats && cardUsageStats.totalDecks > 0;
              const rawPct = hasStats ? (deckCount / cardUsageStats.totalDecks) * 100 : 0;
              const pct = Math.round(rawPct);
              const label = deckCount > 0 && pct === 0 ? "< 1" : String(pct);
              const tier = rawPct >= 76 ? "platinum" : rawPct >= 51 ? "gold" : rawPct >= 26 ? "silver" : deckCount > 0 ? "bronze" : "none";

              if (!showNavigation && !hasStats) return null;

              return (
                <div className="db-modal-bottom-row">
                  {showNavigation && (
                    <span className="db-modal-pagination">{currentIndex + 1} of {results.length}</span>
                  )}
                  {showNavigation && hasStats && <span className="db-modal-separator">·</span>}
                  {hasStats && (
                    <span className={`db-modal-usage usage-${tier}`}>Used in {label}% of decks</span>
                  )}
                </div>
              );
            })()}
          </div>
        </div>
      </div>
    );
  }
}
